import { useState, useEffect } from "react";
import { debounce } from "lodash";

// Conditionally render something after a delay
// Useful for stabilizing boolean values that are changing rapidly
// e.g. loading = A || B || C || D

export default function useDelayedChanges(valuesToMonitor, delay = 200) {
  const [delayedValue, setDelayedValue] = useState(false);

  useEffect(() => {
    if (!delayedValue) setDelayedValue(valuesToMonitor.some(value => value));

    const debouncedUpdate = debounce((newValue) => {
      setDelayedValue(newValue);
    }, delay);
    debouncedUpdate(valuesToMonitor.some(value => value));

    return () => { debouncedUpdate.cancel(); };
  }, [...valuesToMonitor]);

  return delayedValue;
}
